import React, { useEffect, useState } from 'react';
import { Alert, Button, Card, Col, Form, Row, Spinner } from 'react-bootstrap'; // Offcanvas supprimé car non utilisé ici
import { toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom'; // useNavigate pour la redirection
import FormAlert from '../../../commons/FormAlert';
import IconAlert from '../../../../common/IconAlert';
import * as Moment from 'moment';
import api from '@services/api'; // Assurez-vous que le chemin est correct

const ManagePartnerSalons = () => {
  const { id } = useParams();
  const navigate = useNavigate(); // Pour la redirection
  const [trigger, setTrigger] = useState(Date.now()); // Peut-être plus nécessaire si on redirige toujours
  const [object, setObject] = useState({}); // Pour stocker le nom du salon en mode édition
  const [breaks, setBreaks] = useState([]);
  // const [selectedBreakIndex, setSelectedBreakIndex] = useState(null); // Non utilisé, peut être supprimé
  const [isLoading, setIsLoading] = useState(false);
  const [errorForm, setErrorForm] = useState(null); // Initialiser à null pour mieux gérer l'affichage
  const [successForm, setSuccessForm] = useState(null); // Initialiser à null
  const [formData, setFormData] = useState({
    name: '',
    date: '',
    start_time: '09:00',
    end_time: '18:00',
    registration_start_date: '',
    registration_end_date: '',
    slot_duration: 30,
    lunch_break_start_time: '12:00',
    lunch_break_duration: 60,
    breaks: [],
    reminder_start_date: '',
    reminder_frequency: ''
  });

  useEffect(() => {
    const fetchObject = async () => {
      setIsLoading(true);
      try {
        const response = await api.get(`/admin/partner-salons/${id}`);
        if (response.data.success === true) {
          const data = response.data.data;
          setObject(data); // Pour le titre principalement
          setFormData({
            name: data.name || '',
            date: data.date ? Moment(data.date).format('YYYY-MM-DD') : '',
            start_time: data.start_time || '09:00',
            end_time: data.end_time || '18:00',
            registration_start_date: data.registration_start_date
              ? Moment(data.registration_start_date).format('YYYY-MM-DD')
              : '',
            registration_end_date: data.registration_end_date
              ? Moment(data.registration_end_date).format('YYYY-MM-DD')
              : '',
            slot_duration: data.slot_duration || 30,
            lunch_break_start_time: data.lunch_break_start_time || '12:00',
            lunch_break_duration: data.lunch_break_duration || 60,
            reminder_start_date: data.reminder_start_date
              ? Moment(data.reminder_start_date).format('YYYY-MM-DD')
              : '',
            reminder_frequency: data.reminder_frequency || ''
          });
          setBreaks(
            data.breaks
              ? data.breaks.map(b => ({ ...b })) // Assurer une copie pour éviter la mutation directe
              : []
          );
        } else {
          toast(
            response.data.message || 'Erreur lors de la récupération du salon.'
          );
          navigate('/administration/salons-partenaires'); // Rediriger si le salon n'est pas trouvé ou erreur
        }
      } catch (error) {
        console.error('Error fetching salon details:', error);
        toast(
          error.response?.data?.message || 'Une erreur réseau est survenue.'
        );
        navigate('/administration/salons-partenaires');
      } finally {
        setIsLoading(false);
      }
    };
    if (id) {
      fetchObject();
    }
    // Réinitialiser les formulaires si on passe d'un mode édition à un mode ajout sans ID
    if (!id) {
      setObject({});
      setFormData({
        name: '',
        date: '',
        start_time: '09:00',
        end_time: '18:00',
        registration_start_date: '',
        registration_end_date: '',
        slot_duration: 30,
        lunch_break_start_time: '12:00',
        lunch_break_duration: 60,
        reminder_start_date: '',
        reminder_frequency: ''
      });
      setBreaks([]);
    }
  }, [id, navigate]); // trigger enlevé car la redirection gère la "mise à jour" de la vue

  const handleFieldChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const addBreak = () => {
    setBreaks([
      ...breaks,
      { start_time: '10:00', end_time: '11:00' } // isNew n'est plus nécessaire
    ]);
  };

  const handleBreakChange = (index, field, value) => {
    const newBreaks = breaks.map((b, i) =>
      i === index ? { ...b, [field]: value } : b
    );
    setBreaks(newBreaks);
  };

  const removeBreak = indexToRemove => {
    setBreaks(breaks.filter((_, index) => index !== indexToRemove));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setErrorForm(null);
    setSuccessForm(null);
    setIsLoading(true);

    const formDataToSend = {
      ...formData,
      breaks: breaks.map(b => ({
        // S'assurer que seuls start_time et end_time sont envoyés pour les breaks
        start_time: b.start_time,
        end_time: b.end_time
      }))
    };

    try {
      let response;
      if (id) {
        response = await api.put(`/admin/partner-salons/${id}`, formDataToSend);
      } else {
        response = await api.post('/admin/partner-salons', formDataToSend);
      }

      if (response.data.success === true) {
        const salonId = response.data.data.id;
        const successMessage = `Salon partenaire "${response.data.data.name}" ${
          id ? 'mis à jour' : 'enregistré'
        }.`;
        toast(successMessage);
        // setSuccessForm(successMessage); // Plus nécessaire si on redirige
        // setTrigger(Date.now()); // Plus nécessaire

        // Redirection vers la page de détails du salon
        if (salonId) {
          navigate(
            `/administration/salons-partenaires/${salonId}` // Assurez-vous que c'est la bonne URL pour la page "show"
          );
        } else {
          // Fallback si l'ID n'est pas disponible, rediriger vers la liste
          navigate('/administration/salons-partenaires');
        }
      } else {
        // Gérer les erreurs de validation du backend
        if (response.data.data && response.data.data.errors) {
          setErrorForm(response.data.data.errors);
        } else {
          setErrorForm(response.data.message || 'Une erreur est survenue.');
        }
        toast(response.data.message || 'Veuillez vérifier le formulaire.');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      if (error.response && error.response.data) {
        if (error.response.data.data && error.response.data.data.errors) {
          setErrorForm(error.response.data.data.errors);
        } else {
          setErrorForm(
            error.response.data.message || 'Une erreur serveur est survenue.'
          );
        }
        // toast(error.response.data.message || 'Erreur serveur.');
      } else {
        setErrorForm('Une erreur réseau est survenue.');
        toast('Une erreur réseau est survenue.');
      }
    } finally {
      setIsLoading(false);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <>
      {/* Condition pour afficher le formulaire seulement si !isLoading en mode édition, ou toujours en mode ajout */}
      {((id && !isLoading && object.id) || (!id && !isLoading)) && (
        <Form onSubmit={handleSubmit}>
          <Row className="g-3">
            <Col xs={12}>
              <Card>
                <Card.Body>
                  <Row className="flex-between-center">
                    <Col md>
                      <h3 className="mb-2 mb-md-0 text-primary admin-title mb-0">
                        {id
                          ? `Modifier le salon "${object.name || ''}"`
                          : 'Ajouter un salon partenaire'}
                      </h3>
                    </Col>
                    <Col xs="auto">
                      <Button
                        size="sm"
                        variant="falcon-default"
                        className="me-2"
                        onClick={() => {
                          navigate('/administration/salons-partenaires');
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width="20"
                          height="20"
                          style={{ marginBottom: '2px' }}
                        >
                          <path fill="none" d="M0 0h24v24H0z" />
                          <path d="M10.828 12l4.95 4.95-1.414 1.414L8 12l6.364-6.364 1.414 1.414z" />
                        </svg>
                        {!id ? 'Annuler' : 'Retour'}
                      </Button>
                      <Button
                        size="sm"
                        variant="primary"
                        className="me-2 admin-primary"
                        type="submit"
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          'Enregistrement...'
                        ) : (
                          <>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="18"
                              height="18"
                              style={{
                                marginBottom: '2px',
                                marginRight: '4px'
                              }}
                            >
                              <path fill="none" d="M0 0h24v24H0z" />
                              <path
                                d="M7 19v-6h10v6h2V7.828L16.172 5H5v14h2zM4 3h13l4 4v13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm5 12v4h6v-4H9z"
                                fill="rgba(255,255,255,1)"
                              />
                            </svg>
                            Enregistrer
                          </>
                        )}
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
              {errorForm && (
                <div className="mt-3">
                  <FormAlert variant="danger" data={errorForm} />
                </div>
              )}
              {/* successForm n'est plus affiché ici car on redirige */}
            </Col>
            <Col xs={12}>
              <Card className="mb-3 pb-3">
                <Card.Body className="bg-light">
                  <Row className="gx-2 gy-3">
                    <Col md="12">
                      <Form.Group controlId="name">
                        <Form.Label>Nom du salon :</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="Nom du salon partenaire"
                          value={formData.name}
                          onChange={handleFieldChange}
                          isInvalid={!!(errorForm && errorForm.name)}
                        />
                        {errorForm && errorForm.name && (
                          <Form.Control.Feedback type="invalid">
                            {errorForm.name[0]}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </Col>

                    <Col md="4">
                      <Form.Group controlId="date">
                        <Form.Label>Date :</Form.Label>
                        <Form.Control
                          type="date"
                          name="date"
                          value={formData.date}
                          onChange={handleFieldChange}
                          isInvalid={!!(errorForm && errorForm.date)}
                        />
                        {errorForm && errorForm.date && (
                          <Form.Control.Feedback type="invalid">
                            {errorForm.date[0]}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </Col>

                    <Col md="4">
                      <Form.Group controlId="start_time">
                        <Form.Label>Heure de début :</Form.Label>
                        <Form.Control
                          type="time"
                          name="start_time"
                          value={formData.start_time}
                          onChange={handleFieldChange}
                          isInvalid={!!(errorForm && errorForm.start_time)}
                        />
                        {errorForm && errorForm.start_time && (
                          <Form.Control.Feedback type="invalid">
                            {errorForm.start_time[0]}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </Col>

                    <Col md="4">
                      <Form.Group controlId="end_time">
                        <Form.Label>Heure de fin :</Form.Label>
                        <Form.Control
                          type="time"
                          name="end_time"
                          value={formData.end_time}
                          onChange={handleFieldChange}
                          isInvalid={!!(errorForm && errorForm.end_time)}
                        />
                        {errorForm && errorForm.end_time && (
                          <Form.Control.Feedback type="invalid">
                            {errorForm.end_time[0]}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </Col>

                    <Col md="4">
                      <Form.Group controlId="slot_duration">
                        <Form.Label>Durée des créneaux (minutes) :</Form.Label>
                        <Form.Control
                          type="number"
                          min="5"
                          step="5"
                          name="slot_duration"
                          value={formData.slot_duration}
                          onChange={handleFieldChange}
                          isInvalid={!!(errorForm && errorForm.slot_duration)}
                        />
                        {errorForm && errorForm.slot_duration && (
                          <Form.Control.Feedback type="invalid">
                            {errorForm.slot_duration[0]}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </Col>

                    <Col md="4">
                      <Form.Group controlId="lunch_break_start_time">
                        <Form.Label>Début pause déjeuner :</Form.Label>
                        <Form.Control
                          type="time"
                          name="lunch_break_start_time"
                          value={formData.lunch_break_start_time}
                          onChange={handleFieldChange}
                          isInvalid={
                            !!(errorForm && errorForm.lunch_break_start_time)
                          }
                        />
                        {errorForm && errorForm.lunch_break_start_time && (
                          <Form.Control.Feedback type="invalid">
                            {errorForm.lunch_break_start_time[0]}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </Col>

                    <Col md="4">
                      <Form.Group controlId="lunch_break_duration">
                        <Form.Label>
                          Durée pause déjeuner (minutes) :
                        </Form.Label>
                        <Form.Control
                          type="number"
                          min="0"
                          step="5"
                          name="lunch_break_duration"
                          value={formData.lunch_break_duration}
                          onChange={handleFieldChange}
                          isInvalid={
                            !!(errorForm && errorForm.lunch_break_duration)
                          }
                        />
                        {errorForm && errorForm.lunch_break_duration && (
                          <Form.Control.Feedback type="invalid">
                            {errorForm.lunch_break_duration[0]}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </Col>

                    <Col md="12" className="pb-2 pt-3">
                      <div className="border-dashed-bottom"></div>
                    </Col>

                    <Col md="12" className="mt-3">
                      <IconAlert variant="info" className="mb-3">
                        <p className="mb-0">
                          Les dates de vœux déterminent la période pendant
                          laquelle les adhérents/partenaires pourront effectuer
                          leurs souhaits de rendez-vous.
                        </p>
                        <p className="mb-0">
                          Un email sera automatiquement envoyé aux participants
                          lors de l'ouverture des vœux.
                        </p>
                        <p className="mb-0">
                          Le lendemain de la date de fin, l'outil de placement
                          automatique s'exécutera pour générer les plannings de
                          rendez-vous.
                        </p>
                      </IconAlert>
                    </Col>

                    <Col md="4">
                      <Form.Group controlId="registration_start_date">
                        <Form.Label>Début des voeux :</Form.Label>
                        <Form.Control
                          type="date"
                          name="registration_start_date"
                          value={formData.registration_start_date}
                          onChange={handleFieldChange}
                          isInvalid={
                            !!(errorForm && errorForm.registration_start_date)
                          }
                        />
                        {errorForm && errorForm.registration_start_date && (
                          <Form.Control.Feedback type="invalid">
                            {errorForm.registration_start_date[0]}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </Col>

                    <Col md="4">
                      <Form.Group controlId="registration_end_date">
                        <Form.Label>Fin des voeux :</Form.Label>
                        <Form.Control
                          type="date"
                          name="registration_end_date"
                          value={formData.registration_end_date}
                          onChange={handleFieldChange}
                          isInvalid={
                            !!(errorForm && errorForm.registration_end_date)
                          }
                        />
                        {errorForm && errorForm.registration_end_date && (
                          <Form.Control.Feedback type="invalid">
                            {errorForm.registration_end_date[0]}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </Col>

                    <Col md="12" className="pb-2 pt-3">
                      <div className="border-dashed-bottom"></div>
                    </Col>

                    <Col md={12}>
                      <h5 className="admin-title">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width="18"
                          height="18"
                          style={{ marginRight: '4px', marginBottom: '2px' }}
                        >
                          <path fill="none" d="M0 0h24v24H0z" />
                          <path
                            d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm1-8h4v2h-6V7h2v5z"
                            fill="rgba(75,74,77,1)"
                          />
                        </svg>
                        Plages de pauses additionnelles :
                      </h5>

                      <IconAlert variant="info" className="mt-2 mb-3">
                        <p className="mb-0">
                          Définissez des plages horaires pendant lesquelles des
                          pauses seront automatiquement ajoutées. Chaque pause
                          aura la durée d'un créneau ({formData.slot_duration}{' '}
                          minutes). Le système découpera automatiquement ces
                          plages en pauses individuelles.
                        </p>
                      </IconAlert>
                      {errorForm && errorForm.breaks && (
                        <Alert variant="danger" className="mt-2">
                          {typeof errorForm.breaks === 'string'
                            ? errorForm.breaks
                            : 'Erreur avec les plages de pauses.'}
                        </Alert>
                      )}

                      {breaks.map((breakItem, index) => (
                        <Row key={index} className="mt-3 align-items-end">
                          <Col md="5">
                            <Form.Group controlId={`breaks_start_${index}`}>
                              <Form.Label>
                                Début de la plage de pause :
                              </Form.Label>
                              <Form.Control
                                type="time"
                                value={breakItem.start_time}
                                onChange={e =>
                                  handleBreakChange(
                                    index,
                                    'start_time',
                                    e.target.value
                                  )
                                }
                                isInvalid={
                                  !!(
                                    errorForm &&
                                    errorForm[`breaks.${index}.start_time`]
                                  )
                                }
                              />
                              {errorForm &&
                                errorForm[`breaks.${index}.start_time`] && (
                                  <Form.Control.Feedback type="invalid">
                                    {errorForm[`breaks.${index}.start_time`][0]}
                                  </Form.Control.Feedback>
                                )}
                            </Form.Group>
                          </Col>
                          <Col md="5">
                            <Form.Group controlId={`breaks_end_${index}`}>
                              <Form.Label>
                                Fin de la plage de pause :
                              </Form.Label>
                              <Form.Control
                                type="time"
                                value={breakItem.end_time}
                                onChange={e =>
                                  handleBreakChange(
                                    index,
                                    'end_time',
                                    e.target.value
                                  )
                                }
                                isInvalid={
                                  !!(
                                    errorForm &&
                                    errorForm[`breaks.${index}.end_time`]
                                  )
                                }
                              />
                              {errorForm &&
                                errorForm[`breaks.${index}.end_time`] && (
                                  <Form.Control.Feedback type="invalid">
                                    {errorForm[`breaks.${index}.end_time`][0]}
                                  </Form.Control.Feedback>
                                )}
                            </Form.Group>
                          </Col>
                          <Col md="2" className="mb-md-0 mb-2">
                            {' '}
                            {/* Ajustement pour alignement sur mobile */}
                            <Button
                              size="sm"
                              variant="outline-danger" // Moins agressif
                              className="w-100"
                              onClick={() => removeBreak(index)}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="14"
                                height="14"
                                style={{ marginBottom: '2px' }}
                              >
                                <path
                                  d="M7 4V2h10v2h5v2h-2v15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6H2V4h5zM6 6v14h12V6H6zm3 3h2v8H9V9zm4 0h2v8h-2V9z"
                                  fill="currentColor" // Utiliser currentColor pour hériter la couleur du bouton
                                />
                              </svg>
                            </Button>
                          </Col>
                        </Row>
                      ))}
                      {breaks.length === 0 && (
                        <p className="mb-0 mt-2 text-muted">
                          Aucune plage de pause additionnelle configurée.
                        </p>
                      )}

                      <Button
                        size="sm"
                        variant="falcon-default"
                        className="mt-3"
                        onClick={addBreak}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width="20"
                          height="20"
                          style={{ marginBottom: '2px', marginRight: '3px' }}
                        >
                          <path fill="none" d="M0 0h24v24H0z" />
                          <path d="M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2z" />
                        </svg>
                        Ajouter une plage de pause
                      </Button>
                    </Col>
                    <Col md="12" className="pb-2 pt-4">
                      {' '}
                      {/* pt-4 pour plus d'espace */}
                      <div className="border-dashed-bottom"></div>
                    </Col>
                    <Col md={12} className="mt-3">
                      <h5 className="admin-title">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width="18"
                          height="18"
                          style={{ marginRight: '4px', marginBottom: '2px' }}
                          fill="currentColor"
                        >
                          <path d="M20 17H22V19H2V17H4V10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10V17ZM18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10V17H18V10ZM12.7501 21.3376C12.4078 21.725 11.9034 21.9588 11.3751 21.9954C11.1171 22.0123 10.8641 21.9456 10.6741 21.8095C10.4841 21.6734 10.3741 21.477 10.3751 21.2658C10.3751 20.8017 10.7161 20.4195 11.1751 20.3176L11.2501 20.2998C11.9011 20.1438 12.5781 20.5188 12.8251 21.1188L12.7501 21.3376Z" />
                        </svg>
                        Relances automatiques pour les vœux :
                      </h5>
                      <IconAlert variant="info" className="mt-2 mb-3">
                        <p className="mb-0">
                          Configurez des relances automatiques pour les
                          participants (responsables partenaires/entreprises)
                          n'ayant pas encore soumis leurs vœux.
                        </p>
                        <p className="mb-0">
                          Les relances ne sont envoyées que pendant la période
                          de soumission des vœux (entre "Début des vœux" et "Fin
                          des vœux").
                        </p>
                        <p className="mb-0">
                          La première relance est envoyée le jour même de la
                          "Date de début des relances" si celle-ci est atteinte
                          et que les conditions sont remplies.
                        </p>
                      </IconAlert>

                      <Row className="gx-2 gy-3">
                        <Col md="4">
                          <Form.Group controlId="reminder_start_date">
                            <Form.Label>
                              Date de début des relances :
                            </Form.Label>
                            <Form.Control
                              type="date"
                              name="reminder_start_date"
                              value={formData.reminder_start_date}
                              onChange={handleFieldChange}
                              isInvalid={
                                !!(errorForm && errorForm.reminder_start_date)
                              }
                            />
                            {errorForm && errorForm.reminder_start_date && (
                              <Form.Control.Feedback type="invalid">
                                {errorForm.reminder_start_date[0]}
                              </Form.Control.Feedback>
                            )}
                          </Form.Group>
                        </Col>
                        <Col md="4">
                          <Form.Group controlId="reminder_frequency">
                            <Form.Label>Fréquence des relances :</Form.Label>
                            <Form.Select
                              name="reminder_frequency"
                              value={formData.reminder_frequency}
                              onChange={handleFieldChange}
                              isInvalid={
                                !!(errorForm && errorForm.reminder_frequency)
                              }
                            >
                              <option value="">Pas de relance</option>
                              <option value="daily">Tous les jours</option>
                              <option value="every_3_days">
                                Tous les 3 jours
                              </option>
                              <option value="every_7_days">
                                Tous les 7 jours
                              </option>
                            </Form.Select>
                            {errorForm && errorForm.reminder_frequency && (
                              <Form.Control.Feedback type="invalid">
                                {errorForm.reminder_frequency[0]}
                              </Form.Control.Feedback>
                            )}
                          </Form.Group>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
            <Col xs={12}>
              <Card>
                <Card.Body>
                  <Row className="flex-between-center">
                    <Col md></Col>{' '}
                    {/* Espace pour aligner le bouton à droite */}
                    <Col xs="auto">
                      <Button
                        size="sm"
                        variant="falcon-default"
                        className="me-2"
                        onClick={() => {
                          navigate('/administration/salons-partenaires');
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width="20"
                          height="20"
                          style={{ marginBottom: '2px' }}
                        >
                          <path fill="none" d="M0 0h24v24H0z" />
                          <path d="M10.828 12l4.95 4.95-1.414 1.414L8 12l6.364-6.364 1.414 1.414z" />
                        </svg>
                        {!id ? 'Annuler' : 'Retour'}
                      </Button>
                      <Button
                        size="sm"
                        variant="primary"
                        className="me-2 admin-primary"
                        type="submit"
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          'Enregistrement...'
                        ) : (
                          <>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="18"
                              height="18"
                              style={{
                                marginBottom: '2px',
                                marginRight: '4px'
                              }}
                            >
                              <path fill="none" d="M0 0h24v24H0z" />
                              <path
                                d="M7 19v-6h10v6h2V7.828L16.172 5H5v14h2zM4 3h13l4 4v13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm5 12v4h6v-4H9z"
                                fill="rgba(255,255,255,1)"
                              />
                            </svg>
                            Enregistrer
                          </>
                        )}
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Form>
      )}
      {/* Afficher un spinner global si isLoading est true au chargement initial en mode édition */}
      {id && isLoading && !object.id && (
        <Row className="justify-content-center mt-5">
          <Col xs="auto">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Chargement...</span>
            </Spinner>
          </Col>
        </Row>
      )}
    </>
  );
};

export default ManagePartnerSalons;
